import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import "./Css/Analytics.css";
import dropdown from "../assets/arrow_drop_down_24px.svg";
import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  server_post_data,
  get_all_analyticsReservation,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  computeplussevendays,
  handleLinkClick,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery";
import html2canvas from "html2canvas";
import {
  options_select_drop_feedback,
  Analytics_text,
} from "./../CommonJquery/WebsiteText";
import DatePicker from "react-datepicker";
import {
  FileUser,
  FilePlus2,
  SquareChartGantt,
  FileCheck2,
  CalendarCheck,
  CalendarArrowDown,
  ShieldCheck,
  DollarSign,
  ContactRound,
  UserPen,
  ReceiptText,
  BookUser,
} from "lucide-react";

function Analytics() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [customDateActive, setCustomDateActive] = useState(false);
  const [CalenderStartDate, setCalenderStartDate] = useState();
  const [CalenderEndDate, setCalenderEndDate] = useState();
  const [isActive, setIsActive] = useState(false);
  const [selected, setIsSelected] = useState(options_select_drop_feedback[0]);
  const [CardData, setCardData] = useState([]);
  const [series, setseries] = useState([0, 0, 0]);
  const [filteredData, setfilteredData] = useState([]);
  const [filteredData1, setfilteredData1] = useState([]);
  const [filteredData2, setfilteredData2] = useState([]);
  const [filteredData3, setfilteredData3] = useState([]);
  const [filteredOnbooking, setfilteredOnbooking] = useState([]);
  const [showWeekdays, setShowWeekdays] = useState(false);
  const [GraphStatics, setGraphStatics] = useState([]);
  const [Statics, setStatics] = useState([]);
  const [BookingBarData, setBookingBarData] = useState([]);
  const [RevenueBarData, setRevenueBarData] = useState([]);
  const [TotalComplete, setTotalComplete] = useState(0);
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());

  const handleDownloadButtonClick = () => {
    html2canvas(document.body).then((canvas) => {
      const link = document.createElement("a");
      link.download = "Analytics.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  // code by shubham jain for custom date functionality
  useEffect(() => {
    const flag = "1";
    const call_id = "0";
    master_data_get("", "", flag, call_id, selected.value);
  }, []);

  const master_data_get = async (
    start_date,
    end_date,
    flag,
    call_id,
    select_type
  ) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    const current_date = new Date(); // Initialize current_date with the current date
    if (select_type === "today") {
      start_date = start_date_fn(current_date);
      end_date = end_date_fn(current_date);
    } else if (select_type === "last_7_days") {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      start_date = start_date_fn(sevenDaysAgo);
      end_date = end_date_fn(current_date);
    } else if (select_type === "this_month") {
      const firstDayOfMonth = new Date(
        current_date.getFullYear(),
        current_date.getMonth(),
        1
      );
      const lastDayOfMonth = new Date(
        current_date.getFullYear(),
        current_date.getMonth() + 1,
        0
      );
      start_date = start_date_fn(firstDayOfMonth);
      end_date = end_date_fn(lastDayOfMonth);
    } else if (select_type === "last_month") {
      const firstDayOfLastMonth = new Date(
        current_date.getFullYear(),
        current_date.getMonth() - 1,
        1
      );
      const lastDayOfLastMonth = new Date(
        current_date.getFullYear(),
        current_date.getMonth(),
        0
      );
      start_date = start_date_fn(firstDayOfLastMonth);
      end_date = end_date_fn(lastDayOfLastMonth);
    } else if (select_type === "this_year") {
      const firstDayOfYear = new Date(current_date.getFullYear(), 0, 1);
      const lastDayOfYear = new Date(current_date.getFullYear(), 11, 31);
      start_date = start_date_fn(firstDayOfYear);
      end_date = end_date_fn(current_date);
    } else if (select_type === "all") {
      const hundredYearsAgo = new Date(current_date);
      hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
      start_date = start_date_fn(hundredYearsAgo);
      end_date = end_date_fn(current_date);
    }

    function start_date_fn(start_date) {
      // Formatting start date
      const start_year = start_date.getFullYear();
      const start_month = (start_date.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const start_day = start_date.getDate().toString().padStart(2, "0");
      return `${start_year}-${start_month}-${start_day}`;
    }

    function end_date_fn(end_date) {
      // Formatting end date
      const end_year = end_date.getFullYear();
      const end_month = (end_date.getMonth() + 1).toString().padStart(2, "0");
      const end_day = end_date.getDate().toString().padStart(2, "0");
      return `${end_year}-${end_month}-${end_day}`;
    }
    setCalenderStartDate(start_date);
    setCalenderEndDate(end_date);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("select_type", select_type);
    setShowWeekdays(true);
    await server_post_data(get_all_analyticsReservation, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setCardData(Response.data.message);
          setfilteredData(Response.data.message.upcomming_booking);
          setfilteredData1(Response.data.message.old_booking);
          setfilteredData2(Response.data.message.drop_booking);
          setfilteredData3(Response.data.message.upcomming_booking_new);
          setfilteredOnbooking(Response.data.message.Rumming_booking_new);

          // setGraphStatics(ary_list);
          // setBookingBarData(total_count_array);
          // setRevenueBarData(total_payout_amt_array);
          let total_final_complete = 0;

          setTotalComplete(total_final_complete);

          // setStatics(aryList);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  function getFormattedLocalDate(dateString) {
    const dateObj = new Date(dateString); // Convert string to Date object
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const search_data = () => {
    master_data_get(
      getFormattedLocalDate(startDate),
      getFormattedLocalDate(endDate),
      "1",
      "",
      selected.value
    );
  };

  const select_dropdown = (itemsdata) => {
    setIsSelected(itemsdata);
    setIsActive(!isActive);

    if (itemsdata.datepicker_show) {
      setCustomDateActive(true);
    } else {
      setCustomDateActive(false);
      master_data_get("", "", "1", "", itemsdata.value);
    }
  };

  function formatDate(bookDate) {
    // Assuming item.book_date is in the format "yyyy-mm-dd"
    let dateParts = bookDate.split("-");
    let formattedDate = dateParts[2] + "/" + dateParts[1] + "/" + dateParts[0];
    return formattedDate;
  }

  // code by shubham jain for custom date functionality

  const optionsRadial2 = {
    chart: {
      type: "donut",
    },
    labels: ["Direct Reservation", "Walk -In", "Reservation"],
    colors: ["#09c70794", "#509D30", "#67d880"],
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [currentPage3, setCurrentPage3] = useState(1);
  const [currentPageUpcom, setCurrentPageUpcom] = useState(1);
  const [currentPageOnbooking, setCurrentPageOnbooking] = useState(1);

  const [itemsPerPage] = useState(5);
  const [itemsPerPage2] = useState(5);
  const [itemsPerPage3] = useState(5);
  const [itemsPerPageUpcom] = useState(5);
  const [itemsPerPageOnbooking] = useState(5);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfLastItem2 = currentPage2 * itemsPerPage2;
  const indexOfLastItem3 = currentPage3 * itemsPerPage3;
  const indexOfLastItemUpcom = currentPageUpcom * itemsPerPageUpcom;

  const indexOfLastItemOnbooking = currentPageOnbooking * itemsPerPageOnbooking;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const indexOfFirstItem2 = indexOfLastItem2 - itemsPerPage2;
  const indexOfFirstItem3 = indexOfLastItem3 - itemsPerPage3;
  const indexOfFirstUpcom = indexOfLastItemUpcom - itemsPerPageUpcom;

  const indexOfFirstOnbooking =
    indexOfLastItemOnbooking - itemsPerPageOnbooking;

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const currentItems2 = filteredData1.slice(
    indexOfFirstItem2,
    indexOfLastItem2
  );
  const currentItems3 = filteredData2.slice(
    indexOfFirstItem3,
    indexOfLastItem3
  );
  const currentItemsUpcom = filteredData3.slice(
    indexOfFirstUpcom,
    indexOfLastItemUpcom
  );

  const currentItemsOnbooking = filteredOnbooking.slice(
    indexOfFirstOnbooking,
    indexOfLastItemOnbooking
  );
  const totalPageCount = Math.ceil(filteredData.length / itemsPerPage);
  const totalPageCount2 = Math.ceil(filteredData1.length / itemsPerPage2);
  const totalPageCount3 = Math.ceil(filteredData2.length / itemsPerPage3);
  const totalPageCountUpcom = Math.ceil(
    filteredData3.length / itemsPerPageUpcom
  );

  const totalPageCountOnbooking = Math.ceil(
    filteredOnbooking.length / itemsPerPageOnbooking
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const paginate2 = (pageNumber) => {
    setCurrentPage2(pageNumber);
  };
  const paginate3 = (pageNumber) => {
    setCurrentPage3(pageNumber);
  };
  const paginateUpcom = (pageNumber) => {
    setCurrentPageUpcom(pageNumber); // This updates the page number state
  };
  const paginateOnbooking = (pageNumber) => {
    setCurrentPageOnbooking(pageNumber);
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePageClick2 = (pageNumber) => {
    setCurrentPage2(pageNumber);
  };
  const handlePageClick3 = (pageNumber) => {
    setCurrentPage3(pageNumber);
  };
  const handlePageClickUpcom = (pageNumber) => {
    setCurrentPageUpcom(pageNumber); // Same as above, setting the current page number
  };
  const handlePageClickonbooking = (pageNumber) => {
    setCurrentPageOnbooking(pageNumber); // Update the page number
  };

  //------------------pagination 1----------------
  const renderPaginationItems = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPageCount; i++) {
      pageNumbers.push(i);
    }

    if (totalPageCount <= 5) {
      return pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          active={number === currentPage}
          // onClick={() => paginate(number)}
          onClick={() => handlePageClick(number)}
        >
          {number}
        </Pagination.Item>
      ));
    } else {
      const delta = 2;
      const left = currentPage - delta;
      const right = currentPage + delta + 1;
      let pages = [];
      let isEllipsisShown = false;

      for (let i = 1; i <= totalPageCount; i++) {
        if (i === 1 || i === totalPageCount || (i >= left && i < right)) {
          pages.push(i);
        } else if (!isEllipsisShown) {
          pages.push(-1); // -1 indicates ellipsis
          isEllipsisShown = true;
        }
      }

      return pages.map((number, index) => {
        if (number === -1) {
          return <Pagination.Ellipsis key={index} />;
        }
        return (
          <Pagination.Item
            key={index}
            active={number === currentPage}
            onClick={() => paginate(number)}
          >
            {number}
          </Pagination.Item>
        );
      });
    }
  };

  ///--------------Paginatio2---------------- */

  const renderPaginationItems2 = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPageCount2; i++) {
      pageNumbers.push(i);
    }

    if (totalPageCount2 <= 5) {
      return pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          active={number === currentPage2}
          // onClick={() => paginate(number)}
          onClick={() => handlePageClick2(number)}
        >
          {number}
        </Pagination.Item>
      ));
    } else {
      const delta = 2;
      const left = currentPage2 - delta;
      const right = currentPage2 + delta + 1;
      let pages = [];
      let isEllipsisShown = false;

      for (let i = 1; i <= totalPageCount2; i++) {
        if (i === 1 || i === totalPageCount2 || (i >= left && i < right)) {
          pages.push(i);
        } else if (!isEllipsisShown) {
          pages.push(-1); // -1 indicates ellipsis
          isEllipsisShown = true;
        }
      }

      return pages.map((number, index) => {
        if (number === -1) {
          return <Pagination.Ellipsis key={index} />;
        }
        return (
          <Pagination.Item
            key={index}
            active={number === currentPage2}
            onClick={() => paginate2(number)}
          >
            {number}
          </Pagination.Item>
        );
      });
    }
  };
  ///--------------Paginatio3---------------- */
  const renderPaginationItems3 = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPageCount3; i++) {
      pageNumbers.push(i);
    }

    if (totalPageCount3 <= 5) {
      return pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          active={number === currentPage3}
          // onClick={() => paginate(number)}
          onClick={() => handlePageClick3(number)}
        >
          {number}
        </Pagination.Item>
      ));
    } else {
      const delta = 2;
      const left = currentPage3 - delta;
      const right = currentPage3 + delta + 1;
      let pages = [];
      let isEllipsisShown = false;

      for (let i = 1; i <= totalPageCount3; i++) {
        if (i === 1 || i === totalPageCount3 || (i >= left && i < right)) {
          pages.push(i);
        } else if (!isEllipsisShown) {
          pages.push(-1); // -1 indicates ellipsis
          isEllipsisShown = true;
        }
      }

      return pages.map((number, index) => {
        if (number === -1) {
          return <Pagination.Ellipsis key={index} />;
        }
        return (
          <Pagination.Item
            key={index}
            active={number === currentPage3}
            onClick={() => paginate3(number)}
          >
            {number}
          </Pagination.Item>
        );
      });
    }
  };
  ///--------------Paginatio Upcoming--------------- */
  const renderPaginationItemsUpcom = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPageCountUpcom; i++) {
      pageNumbers.push(i);
    }

    if (totalPageCountUpcom <= 5) {
      return pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          active={number === currentPageUpcom}
          onClick={() => handlePageClickUpcom(number)}
        >
          {number}
        </Pagination.Item>
      ));
    } else {
      const delta = 2;
      const left = currentPageUpcom - delta;
      const right = currentPageUpcom + delta + 1;
      let pages = [];
      let isEllipsisShown = false;

      for (let i = 1; i <= totalPageCountUpcom; i++) {
        if (i === 1 || i === totalPageCountUpcom || (i >= left && i < right)) {
          pages.push(i);
        } else if (!isEllipsisShown) {
          pages.push(-1);
          isEllipsisShown = true;
        }
      }

      return pages.map((number, index) => {
        if (number === -1) {
          return <Pagination.Ellipsis key={index} />;
        }
        return (
          <Pagination.Item
            key={index}
            active={number === currentPageUpcom}
            onClick={() => paginateUpcom(number)}
          >
            {number}
          </Pagination.Item>
        );
      });
    }
  };
  ///--------------Paginatio On booking --------------- */
  const renderPaginationItemsOnbooking = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPageCountOnbooking; i++) {
      pageNumbers.push(i);
    }

    if (totalPageCountOnbooking <= 5) {
      return pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          active={number === currentPageOnbooking}
          onClick={() => handlePageClickonbooking(number)}
        >
          {number}
        </Pagination.Item>
      ));
    } else {
      const delta = 2;
      const left = currentPageOnbooking - delta;
      const right = currentPageOnbooking + delta + 1;
      let pages = [];
      let isEllipsisShown = false;

      for (let i = 1; i <= totalPageCountOnbooking; i++) {
        if (
          i === 1 ||
          i === totalPageCountOnbooking ||
          (i >= left && i < right)
        ) {
          pages.push(i);
        } else if (!isEllipsisShown) {
          pages.push(-1); // -1 indicates ellipsis
          isEllipsisShown = true;
        }
      }

      return pages.map((number, index) => {
        if (number === -1) {
          return <Pagination.Ellipsis key={index} />;
        }
        return (
          <Pagination.Item
            key={index}
            active={number === currentPageOnbooking}
            onClick={() => paginateOnbooking(number)}
          >
            {number}
          </Pagination.Item>
        );
      });
    }
  };

  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [activeTab, setActiveTab] = useState("History");

  // Function to handle tab switching
  const toggleTabs = (tabName) => {
    setActiveTab(tabName);
  };
  const scrollToTopWithOffset = () => {
    const element = document.getElementById("tabsDataTop");
    if (element) {
      const offset = 85;
      window.scrollTo({
        top: element.offsetTop - offset,
        behavior: "smooth",
      });
    }
  };
  const handleLink = (path, statusValue = null) => {
    if (statusValue !== null) {
      localStorage.setItem("selectedStatusFilter", statusValue);
    }
    navigate(path);
  };
  const handleDateChange = (date) => {
    setStartDate(date);
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head stickyHeaderClssDash">
              <div className="analyticsHead">
                <div className="analyticFIlter">
                  <div className="col-xl-10">
                    <div className="row m-0">
                      <div className="col-md-4">
                        <div className="dropdownCustom" ref={dropdownRef}>
                          <div
                            onClick={(e) => {
                              setIsActive(!isActive);
                            }}
                            className="dropdownCustom-btn"
                          >
                            {Analytics_text.Period_text}: {selected.label}
                            <span
                              className={
                                isActive
                                  ? "fas fa-caret-up"
                                  : "fas fa-caret-down"
                              }
                            >
                              <img src={dropdown} alt="Rapid Car Leasing" />
                            </span>
                          </div>
                          <div
                            className="dropdownCustom-content"
                            style={{ display: isActive ? "block" : "none" }}
                          >
                            {options_select_drop_feedback.map(function (
                              items,
                              index
                            ) {
                              return (
                                <div
                                  onClick={(e) => {
                                    select_dropdown(items);
                                  }}
                                  className="itemDrop"
                                  key={index}
                                >
                                  {items.label}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      {customDateActive && (
                        <>
                          <div className="col-md-3 bottomAlgin">
                            <div className="person__calenderFrame_image image_icon_position1 custn_possitin_icn ">
                              <DatePicker
                                selected={startDate}
                                onChange={handleDateChange}
                                className="form-control input_field_custom4"
                                maxDate={computeTodayDate()}
                                dateFormat="MM-dd-yyyy"
                                placeholderText="MM-DD-YYYY"
                              />
                            </div>
                          </div>
                          <div className="col-md-3 bottomAlgin">
                            <div className="person__calenderFrame_image image_icon_position1 custn_possitin_icn ">
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control input_field_custom4"
                                maxDate={computeTodayDate()}
                                minDate={startDate}
                                dateFormat="MM-dd-yyyy"
                                placeholderText="MM-DD-YYYY"
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="downloadBtnAna ">
                              <button onClick={() => search_data()}>
                                {Analytics_text.Search_text}
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="downloadBtnAna">
                  <button onClick={handleDownloadButtonClick}>
                    {Analytics_text.download_text}
                  </button>
                </div> */}
              </div>
            </div>

            <div className="page_body">
              <div className="analytics">
                <div className="analytics_container mt-2">
                  <div className="row m-0">
                    <div className="col-md-12">
                      <div className="row m-0 h-100">
                        <div className="col-lg-3 col-md-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => handleLinkClick("/Bookings")}
                          >
                            <div>
                              <p>Total Applications</p>
                              <h5>{CardData.all_application}</h5>
                            </div>
                            <div className="icons_Caontianer_dash blue">
                              <FileUser size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              handleLink("/Bookings", "0");
                            }}
                          >
                            <div>
                              <p>New Applications </p>
                              <h5>{CardData.all_pending}</h5>
                            </div>
                            <div className="icons_Caontianer_dash yellow">
                              <FilePlus2 size={24} />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-4  paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => handleLink("/Bookings", "1")}
                          >
                            <div>
                              <p>Applications in Review</p>
                              <h5>{CardData.all_pending_new}</h5>
                            </div>
                            <div className="icons_Caontianer_dash orange">
                              <SquareChartGantt size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-4  paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard "
                            onClick={() => {
                              handleLink("/Bookings", "5");
                            }}
                          >
                            <div>
                              <p>Completed Bookings</p>
                              <h5>{CardData.all_compeletd_booking}</h5>
                            </div>
                            <div className="icons_Caontianer_dash green">
                              <FileCheck2 size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              navigate("/Maintanance", {
                                state: {
                                  data: "Upcoming",
                                },
                              });
                            }}
                          >
                            <div>
                              <p>Scheduled Maintenance</p>
                              <h5>{CardData.today_maintainance}</h5>
                            </div>
                            <div className="icons_Caontianer_dash yellow">
                              <CalendarCheck size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              navigate("/Maintanance", {
                                state: {
                                  data: "Overdue",
                                },
                              });
                            }}
                          >
                            <div>
                              <p>Overdue Maintenance</p>
                              <h5>{CardData.Overdue_maintainance}</h5>
                            </div>
                            <div className="icons_Caontianer_dash red">
                              <CalendarArrowDown size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              handleLink("/view_cardetails");
                            }}
                          >
                            <div>
                              <p>Active Fleet</p>
                              <h5>{CardData.active_cars}</h5>
                            </div>
                            <div className="icons_Caontianer_dash blue">
                              <ShieldCheck size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div className="analyticsCard">
                            <div>
                              <p>Total Revenue</p>
                              <h5>
                                {CardData?.total_balance_car?.total_balance ||
                                  0}
                              </h5>
                            </div>
                            <div className="icons_Caontianer_dash green">
                              <DollarSign size={24} />
                            </div>
                          </div>
                        </div>
                        {/* New Cards Leads and Enquiries */}
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              handleLink("/Lead_Managment");
                            }}
                          >
                            <div>
                              <p>Today's Leads</p>
                              <h5>{CardData?.all_leads_today || 0}</h5>
                            </div>
                            <div className="icons_Caontianer_dash grey">
                              <UserPen size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              handleLink("/Enquiries");
                            }}
                          >
                            <div>
                              <p>Today's Enquiries</p>
                              <h5>{CardData?.all_enquiry_today || 0}</h5>
                            </div>
                            <div className="icons_Caontianer_dash blueGrey">
                              <ReceiptText size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              handleLink("/Lead_Managment");
                            }}
                          >
                            <div>
                              <p>Total Leads</p>
                              <h5>{CardData?.all_leads || 0}</h5>
                            </div>
                            <div className="icons_Caontianer_dash orange">
                              <ContactRound size={24} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3 mt-4 paddingLeft1200 marginClss">
                          <div
                            className="analyticsCard"
                            onClick={() => {
                              handleLink("/Enquiries");
                            }}
                          >
                            <div>
                              <p>Total Enquiries</p>
                              <h5>{CardData?.all_enquiry || 0}</h5>
                            </div>
                            <div className="icons_Caontianer_dash yellow">
                              <BookUser size={24} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tabsDataTop" id="tabsDataTop">
                    <div className="calendertabs">
                      <div className="calendertabs_container2">
                        {" "}
                        <div
                          className={`calendertabsBtn ${
                            activeTab === "History" ? "activeCalendarTab2" : ""
                          }`}
                          onClick={() => toggleTabs("History")}
                          style={{ marginLeft: "1rem" }}
                        >
                          <p> Recent Applications</p>
                        </div>
                        <div
                          className={`calendertabsBtn ${
                            activeTab === "OngoingBooking"
                              ? "activeCalendarTab2"
                              : ""
                          }`}
                          onClick={() => toggleTabs("OngoingBooking")}
                        >
                          <p>Ongoing Booking</p>
                        </div>
                        <div
                          className={`calendertabsBtn ${
                            activeTab === "UpcommingMaintenance"
                              ? "activeCalendarTab2"
                              : ""
                          }`}
                          onClick={() => toggleTabs("UpcommingMaintenance")}
                        >
                          <p>Upcomming Maintenance</p>
                        </div>
                        <div
                          className={`calendertabsBtn ${
                            activeTab === "OverdueMaintenance"
                              ? "activeCalendarTab2"
                              : ""
                          }`}
                          onClick={() => toggleTabs("OverdueMaintenance")}
                        >
                          <p>Overdue Maintenance</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {activeTab === "History" && (
                    <div className="feedBackTable FeedBackMArgin">
                      <div className="feedBackTable_container">
                        {/* <h5 className="mt-4">Recent Booking</h5> */}
                        {/**---------------------------Table 1--------------------------- */}
                        <div className="maintancelog-table-container">
                          <div className="maintancelog-table-wrapper">
                            <table
                              id="myTable"
                              ref={tableRef}
                              className="maintancelog-table"
                            >
                              <thead className="maintancelog-table-header">
                                <tr>
                                  <th scope="col" className="th3">
                                    Sr.No
                                  </th>
                                  <th scope="col">Entry Date</th>
                                  <th scope="col">Driver Name</th>
                                  <th scope="col">Phone</th>
                                  <th scope="col">Email</th>
                                  <th scope="col">Car Name</th>
                                  {/* <th className="th4">Status</th> */}
                                </tr>
                                <tr style={{ height: "25px" }}></tr>
                              </thead>
                              <tbody className="maintancelog-table-body ">
                                {currentItemsUpcom &&
                                  currentItemsUpcom.map((item, index) => (
                                    <React.Fragment key={index}>
                                      <tr
                                        key={index}
                                        className="maintancelog-table-row"
                                      >
                                        <td>
                                          <div
                                            className="maintancelog-cell maintancelog-center"
                                            style={{ marginLeft: "20px" }}
                                          >
                                            <p>
                                              {indexOfFirstUpcom + index + 1}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {mondayDayYearFormat(
                                                item.entry_date
                                              )}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {item.first_name} {""}
                                              {item.last_name}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>{item.mobile_no}</p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>{item.email}</p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            {item.car_name}
                                          </div>
                                        </td>
                                        {/* <td>
                                          <div className="downloadBtnAna">
                                            <button
                                            // onClick={handleDownloadButtonClick}
                                            >
                                              Enquiry
                                            </button>
                                          </div>
                                        </td> */}
                                      </tr>

                                      <tr
                                        style={{
                                          height: "1rem",
                                          boxShadow: "none",
                                        }}
                                      ></tr>
                                    </React.Fragment>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="Dash-pagination">
                            <div className="cust_hist_pagination_info">
                              {filteredData3 && filteredData3.length > 0 ? (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {indexOfFirstUpcom + 1}
                                  </span>{" "}
                                  to{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {Math.min(
                                      indexOfLastItemUpcom,
                                      filteredData3.length
                                    )}
                                  </span>{" "}
                                  of{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {filteredData3.length}
                                  </span>{" "}
                                  Applications
                                </>
                              ) : (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    0
                                  </span>{" "}
                                  Application
                                </>
                              )}
                            </div>
                            <div className="pagination-control">
                              <button
                                className="pagination-button"
                                onClick={() =>
                                  setCurrentPageUpcom(currentPageUpcom - 1)
                                }
                                disabled={currentPageUpcom === 1}
                              >
                                {"←"} Previous
                              </button>

                              {/* Page number display */}
                              {currentPageUpcom > 2 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageUpcom(currentPageUpcom - 2)
                                  }
                                >
                                  {currentPageUpcom - 2}
                                </div>
                              )}

                              {currentPageUpcom > 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageUpcom(currentPageUpcom - 1)
                                  }
                                >
                                  {currentPageUpcom - 1}
                                </div>
                              )}

                              <div className="pagination-number active">
                                {currentPageUpcom}
                              </div>

                              {currentPageUpcom < totalPageCountUpcom && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageUpcom(currentPageUpcom + 1)
                                  }
                                >
                                  {currentPageUpcom + 1}
                                </div>
                              )}

                              {currentPageUpcom < totalPageCountUpcom - 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageUpcom(currentPageUpcom + 2)
                                  }
                                >
                                  {currentPageUpcom + 2}
                                </div>
                              )}

                              <button
                                className="pagination-button"
                                onClick={() =>
                                  setCurrentPageUpcom(currentPageUpcom + 1)
                                }
                                disabled={
                                  currentPageUpcom === totalPageCountUpcom
                                }
                              >
                                Next {"→"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === "UpcommingMaintenance" && (
                    // <div className="comingNextphaseTxt m-0">
                    //   <img src={newfeaureIcn} alt="newfeaureIcn"></img>
                    //   <div className="txtData">
                    //     <p style={{ fontSize: "18px", fontWeight: "600" }}>
                    //       Something incredible is on the way! Our next phase is
                    //       packed with powerful new features.
                    //     </p>
                    //     <p>
                    //       Get ready for an upgraded experience like never
                    //       before!
                    //     </p>
                    //   </div>
                    // </div>
                    <div className="feedBackTable FeedBackMArgin">
                      <div className="feedBackTable_container">
                        {/* <h5 className="mt-4">Upcommnig Maintenance</h5> */}

                        <div className="maintancelog-table-container">
                          <div className="maintancelog-table-wrapper">
                            <table
                              id="myTable"
                              ref={tableRef}
                              className="maintancelog-table"
                            >
                              <thead className="maintancelog-table-header">
                                <tr>
                                  <th scope="col" className="th3">
                                    {Analytics_text.s_no}
                                  </th>
                                  <th scope="col">Car Code</th>
                                  <th scope="col">Car Name</th>
                                  <th scope="col">Car No.</th>
                                  <th scope="col">Last Maintenance</th>
                                  <th scope="col">Next Maintenance</th>
                                </tr>
                                <tr style={{ height: "25px" }}></tr>
                              </thead>
                              <tbody className="maintancelog-table-body">
                                {currentItems &&
                                  currentItems.map((item, index) => (
                                    <React.Fragment key={index}>
                                      <tr
                                        key={index}
                                        className="maintancelog-table-row"
                                      >
                                        <td>
                                          <div
                                            className="maintancelog-cell maintancelog-center"
                                            style={{ marginLeft: "20px" }}
                                          >
                                            <p>
                                              {indexOfFirstItem + index + 1}
                                            </p>{" "}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {/* {item &&
                                                item.car_data.length > 0 &&
                                                item.car_data[0].car_name} */}
                                              {item.car_tagline}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {/* {item &&
                                                item.car_data.length > 0 &&
                                                item.car_data[0].car_name} */}
                                              {item.car_name}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {item.car_no}
                                              {/* {item. &&
                                                item.car_data.length > 0 &&
                                                item.car_data[0].car_no} */}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {mondayDayYearFormat(
                                                item.last_maintenance_date
                                              )}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {mondayDayYearFormat(
                                                item.next_maintenance_date
                                              )}
                                            </p>
                                          </div>
                                        </td>
                                        {/* <td>
                                          <div className="recentContact">
                                            {item.last_maintenance_km}
                                          </div>
                                        </td> */}
                                      </tr>

                                      <tr
                                        style={{
                                          height: "1rem",
                                          boxShadow: "none",
                                        }}
                                      ></tr>
                                    </React.Fragment>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="Dash-pagination">
                            <div className="cust_hist_pagination_info">
                              {filteredData && filteredData.length > 0 ? (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {indexOfFirstItem + 1}
                                  </span>{" "}
                                  to{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {Math.min(
                                      indexOfLastItem,
                                      filteredData.length
                                    )}
                                  </span>{" "}
                                  of{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {filteredData.length}
                                  </span>{" "}
                                  Vehicles
                                </>
                              ) : (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    0
                                  </span>{" "}
                                  Vehicle
                                </>
                              )}
                            </div>
                            <div className="pagination-control">
                              <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage === 1}
                              >
                                {"←"} Previous
                              </button>

                              {/* Page number display */}
                              {currentPage > 2 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage(currentPage - 2)
                                  }
                                >
                                  {currentPage - 2}
                                </div>
                              )}

                              {currentPage > 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage(currentPage - 1)
                                  }
                                >
                                  {currentPage - 1}
                                </div>
                              )}

                              <div className="pagination-number active">
                                {currentPage}
                              </div>

                              {currentPage < totalPageCount && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage(currentPage + 1)
                                  }
                                >
                                  {currentPage + 1}
                                </div>
                              )}

                              {currentPage < totalPageCount - 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage(currentPage + 2)
                                  }
                                >
                                  {currentPage + 2}
                                </div>
                              )}

                              <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={currentPage === totalPageCount}
                              >
                                Next {"→"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/**---------------------------Table 2--------------------------- */}
                  {activeTab === "OverdueMaintenance" && (
                    <div className="feedBackTable FeedBackMArgin">
                      <div className="feedBackTable_container">
                        {/* <h5 className="mt-4">Overdue Maintenance</h5> */}
                        <div className="maintancelog-table-container">
                          <div className="maintancelog-table-wrapper">
                            <table
                              id="myTable"
                              ref={tableRef}
                              className="maintancelog-table"
                            >
                              <thead className="maintancelog-table-header">
                                <tr>
                                  <th scope="col" className="th3">
                                    {Analytics_text.s_no}
                                  </th>
                                  <th scope="col">Car Code</th>
                                  <th scope="col">Car Name</th>
                                  <th scope="col">Car No.</th>
                                  <th scope="col">Last Maintenance</th>
                                  <th scope="col">Next Maintenance</th>
                                </tr>
                                <tr style={{ height: "25px" }}></tr>
                              </thead>
                              <tbody className="maintancelog-table-body">
                                {currentItems2 &&
                                  currentItems2.map((item, index) => (
                                    <React.Fragment key={index}>
                                      <tr
                                        key={index}
                                        className="maintancelog-table-row"
                                      >
                                        <td>
                                          <div
                                            className="maintancelog-cell maintancelog-center"
                                            style={{ marginLeft: "20px" }}
                                          >
                                            <p>
                                              {indexOfFirstItem2 + index + 1}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {/* {item &&
                                                item.car_data.length > 0 &&
                                                item.car_data[0].car_name} */}
                                              {item.car_tagline}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {/* {item &&
                                                item.car_data.length > 0 &&
                                                item.car_data[0].car_name} */}
                                              {item.car_name}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {item.car_no}
                                              {/* {item. &&
                                                item.car_data.length > 0 &&
                                                item.car_data[0].car_no} */}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {" "}
                                              {mondayDayYearFormat(
                                                item.last_maintenance_date
                                              )}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {" "}
                                              {mondayDayYearFormat(
                                                item.next_maintenance_date
                                              )}
                                            </p>
                                          </div>
                                        </td>
                                        {/* <td>
                                          <div className="recentContact">
                                            {item.last_maintenance_km}
                                          </div>
                                        </td> */}
                                      </tr>

                                      <tr
                                        style={{
                                          height: "1rem",
                                          boxShadow: "none",
                                        }}
                                      ></tr>
                                    </React.Fragment>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="Dash-pagination">
                            <div className="cust_hist_pagination_info">
                              {filteredData1 && filteredData1.length > 0 ? (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {indexOfFirstItem2 + 1}
                                  </span>{" "}
                                  to{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {Math.min(
                                      indexOfLastItem2,
                                      filteredData1.length
                                    )}
                                  </span>{" "}
                                  of{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {filteredData1.length}
                                  </span>{" "}
                                  Vehicles
                                </>
                              ) : (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    0
                                  </span>{" "}
                                  Vehicle
                                </>
                              )}
                            </div>
                            <div className="pagination-control">
                              <button
                                className="pagination-button"
                                onClick={() =>
                                  setCurrentPage2(currentPage2 - 1)
                                }
                                disabled={currentPage2 === 1}
                              >
                                {"←"} Previous
                              </button>

                              {/* Page number display */}
                              {currentPage2 > 2 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage2(currentPage2 - 2)
                                  }
                                >
                                  {currentPage2 - 2}
                                </div>
                              )}

                              {currentPage2 > 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage2(currentPage2 - 1)
                                  }
                                >
                                  {currentPage2 - 1}
                                </div>
                              )}

                              <div className="pagination-number active">
                                {currentPage2}
                              </div>

                              {currentPage2 < totalPageCount2 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage2(currentPage2 + 1)
                                  }
                                >
                                  {currentPage2 + 1}
                                </div>
                              )}

                              {currentPage2 < totalPageCount2 - 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPage2(currentPage2 + 2)
                                  }
                                >
                                  {currentPage2 + 2}
                                </div>
                              )}

                              <button
                                className="pagination-button"
                                onClick={() =>
                                  setCurrentPage2(currentPage2 + 1)
                                }
                                disabled={currentPage2 === totalPageCount2}
                              >
                                Next {"→"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/**---------------------------Table 3--------------------------- */}
                  {activeTab === "OngoingBooking" && (
                    <div className="feedBackTable FeedBackMArgin">
                      <div className="feedBackTable_container">
                        {/* <h5 className="mt-4">Ongoing Booking</h5> */}
                        <div className="maintancelog-table-container">
                          <div className="maintancelog-table-wrapper">
                            <table
                              id="myTable"
                              ref={tableRef}
                              className="maintancelog-table"
                            >
                              <thead className="maintancelog-table-header">
                                <tr>
                                  <th scope="col" className="th3">
                                    {Analytics_text.s_no}
                                  </th>
                                  <th scope="col">Entry Date</th>
                                  <th scope="col">Driver Name</th>
                                  <th scope="col">Phone</th>
                                  <th scope="col">Email</th>
                                  <th scope="col">Car Name</th>
                                  {/* <th className="th4">Status</th> */}
                                </tr>
                                <tr style={{ height: "25px" }}></tr>
                              </thead>
                              <tbody className="maintancelog-table-body">
                                {currentItemsOnbooking &&
                                  currentItemsOnbooking.map((item, index) => (
                                    <React.Fragment key={index}>
                                      <tr
                                        key={index}
                                        className="maintancelog-table-row"
                                      >
                                        <td>
                                          <div
                                            className="maintancelog-cell maintancelog-center"
                                            style={{ marginLeft: "20px" }}
                                          >
                                            <p>
                                              {indexOfFirstOnbooking +
                                                index +
                                                1}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {mondayDayYearFormat(
                                                item.entry_date
                                              )}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>
                                              {item.first_name} {""}
                                              {item.last_name}
                                            </p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>{item.mobile_no}</p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            <p>{item.email}</p>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="maintancelog-cell">
                                            {item.car_name}
                                          </div>
                                        </td>
                                        {/* <td>
                                          <div className="downloadBtnAna">
                                            <button
                                            // onClick={handleDownloadButtonClick}
                                            >
                                              New
                                            </button>
                                          </div>
                                        </td> */}
                                      </tr>

                                      <tr
                                        style={{
                                          height: "1rem",
                                          boxShadow: "none",
                                        }}
                                      ></tr>
                                    </React.Fragment>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="Dash-pagination">
                            <div className="cust_hist_pagination_info">
                              {filteredOnbooking &&
                              filteredOnbooking.length > 0 ? (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {indexOfFirstOnbooking + 1}
                                  </span>{" "}
                                  to{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {Math.min(
                                      indexOfLastItemOnbooking,
                                      filteredOnbooking.length
                                    )}
                                  </span>{" "}
                                  of{" "}
                                  <span className="cust_hist_pagination_bold">
                                    {filteredOnbooking.length}
                                  </span>{" "}
                                  Bookings
                                </>
                              ) : (
                                <>
                                  Showing{" "}
                                  <span className="cust_hist_pagination_bold">
                                    0
                                  </span>{" "}
                                  Booking
                                </>
                              )}
                            </div>
                            <div className="pagination-control">
                              <button
                                className="pagination-button"
                                onClick={() =>
                                  setCurrentPageOnbooking(
                                    currentPageOnbooking - 1
                                  )
                                }
                                disabled={currentPageOnbooking === 1}
                              >
                                {"←"} Previous
                              </button>

                              {/* Page number display */}
                              {currentPageOnbooking > 2 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageOnbooking(
                                      currentPageOnbooking - 2
                                    )
                                  }
                                >
                                  {currentPageOnbooking - 2}
                                </div>
                              )}

                              {currentPageOnbooking > 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageOnbooking(
                                      currentPageOnbooking - 1
                                    )
                                  }
                                >
                                  {currentPageOnbooking - 1}
                                </div>
                              )}

                              <div className="pagination-number active">
                                {currentPageOnbooking}
                              </div>

                              {currentPageOnbooking <
                                totalPageCountOnbooking && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageOnbooking(
                                      currentPageOnbooking + 1
                                    )
                                  }
                                >
                                  {currentPageOnbooking + 1}
                                </div>
                              )}

                              {currentPageOnbooking <
                                totalPageCountOnbooking - 1 && (
                                <div
                                  className="pagination-number"
                                  onClick={() =>
                                    setCurrentPageOnbooking(
                                      currentPageOnbooking + 2
                                    )
                                  }
                                >
                                  {currentPageOnbooking + 2}
                                </div>
                              )}

                              <button
                                className="pagination-button"
                                onClick={() =>
                                  setCurrentPageOnbooking(
                                    currentPageOnbooking + 1
                                  )
                                }
                                disabled={
                                  currentPageOnbooking ===
                                  totalPageCountOnbooking
                                }
                              >
                                Next {"→"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analytics;
